import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex items-center flex-wrap gap-1 text-xs md:text-sm text-foreground-500">
      <i className="ri-home-4-line mr-1"></i>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-500 cursor-pointer transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-800' : ''}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          </span>
        );
      })}
    </nav>
  );
}